import styled from "styled-components";
import {FormCheck} from "react-bootstrap";

export const RelayArticle= styled.article`
  border-radius: 15px;
  outline: 1px solid black;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  max-width: 200px;
  width: 100%;
  //height: 190px;

  //&:hover {
  //  background: rgba(246, 238, 229, 0.5);
  //}

  @media (max-width: 760px) {
    &:hover {
      background: transparent;
    }

    cursor: none;
  }
`

export const RelayText= styled.p`
  margin: 0 0 2px 0;
  padding: 0 2px 0 2px;
`

export const RelayImg = styled.img`
  margin-top: 10px;
  object-fit: cover;
  height: 100%;
  max-height: 70px;
`

export const RelayFormCheck = styled(FormCheck)`
    input {
      height: 23px;
      width: 50px !important;
    }
`
